import { IAppConfig } from "./interface";

export default <IAppConfig> {
	authEnabled: true,
	autoLogoutEnabled: true,
	firebaseMessagingLogging: false, //process.env.NODE_ENV !== 'production',
	eImzoLogging: false, // process.env.NODE_ENV !== 'production',
	availableRouteNames: [
		"HowRegister",
		"HowRegisterPlans",
		"HowRegisterDocs",
		"Home",
		"ECommerce",
		"Services",
		"Login",
		"CompanyAccounts",
		"CompanyAccounts-content",
		"Plans",
		"SendingSwiftContent",
		"SendingSwiftContentPath",
		"StatusPaymentDrafts",
		"StatusPaymentApproval",
		"StatusPaymentInbox",
		"StatusPaymentRevision",
		"Settings",
		"Support",
		"Employees",
		"Employees-content",
		"ExchangeRates",
		"CardIndex",
		"ModuleLoan",
		'CardReplenishment',
		'PayrollUpload',
		'NewPayroll',
		'PayrollMain',
		'Munis',
		'MunisNewPayment',
		'MunisTemplates',
		'MunisSettlement',
		'Register',
		'CreateSumPayment-content',
		'TransactionsHistory',
		'TransactionsRegisterHistory',
		'TrRegisterHistoryInfo',
		'TransactionsPayrollHistory',
		'TrPayrollHistoryInfo',
		'TrPayrollHistoryInfoLayout',
		'TransactionsSwiftHistory',
		'TransactionsCurrencyHistory',
		'Counterparties',
		'AddedCounterparties',
		'IBCounterparties-content',
		"Reports",
		'CreateSumPayment',
		'Forex',
		'ForexBuy',
		'ForexSell',
		'ForexDraft',
		'ForexTemplate',
		'ForexApproval',
		'paymentRequirementsIncoming',
		'paymentRequirementsOutgoing',
		'paymentRequirementsIncomingPay',
		'paymentRequirementsCreation',
		'loginHelp',
		// ------ UI --start
		"uiLib",
		"uiLibDatePicker",
		"uiLibDialog",
		'uiLib3DSelect',
		'uiLib3DSelectWithout3d',
		'uiLibNewEImzo'
		// ------ UI --end
	]
};
